import React, { useState, useEffect } from 'react'

import { Card, Span } from 'components'
import { useModal, useLoading, useToggle } from 'hooks'
import { JobsService, GetAllJobsResponse } from 'services/NGT/Parameterization'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import { ModalEditJob, TableJobs } from './components'
import MultipleDaySelect from './components/ModalNovJobs/components/Periodicidade/components/Mensal/components/MultipleDaySelect'

const Jobs: React.FC = () => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()
  const [modalEditJobs, toggleModalEditJobs] = useToggle()
  const [refreshScreen, toggleRefreshScreen] = useToggle()

  const [tableData, setTableData] = useState<GetAllJobsResponse[]>([])
  const [job, setJob] = useState<GetAllJobsResponse | undefined>()

  const getAllJobs = () => {
    setLoading('loading')

    JobsService()
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          const { data: tableData } = response

          setTableData(tableData)
        }

        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os JOBS',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  useEffect(() => {
    getAllJobs()
  }, [modalEditJobs, refreshScreen])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Span
          text="JOBS CADASTRADOS"
          fontSize={TYPOGRAPHY.subtitleSize20}
          fontWeight={FONTS.bold}
          marginTop={SPACING.spacing10}
          marginBottom={SPACING.spacing10}
        />
        {tableData && tableData.length > 0 && (
          <TableJobs
            tableData={tableData}
            setJob={setJob}
            toggleModalEditJobs={toggleModalEditJobs}
            toggleRefreshScreen={toggleRefreshScreen}
          />
        )}
      </Card>
      <ModalEditJob
        job={job}
        showModalJob={modalEditJobs}
        toggleModal={toggleModalEditJobs}
      />
    </>
  )
}

export default Jobs
